import React, { useContext, useState } from "react";
import _ from "lodash";
import { UserContext, Utils } from "../../common";

const hasAnyPath = (pathary) => {
  return _.filter(pathary, (path) => window.location.pathname.indexOf(path) > -1).length > 0;
};

const Sidebar = () => {
  const { userData, setShowHowToModal, goTraining } = useContext(UserContext);
  const [training, setTraining] = useState(false);

  const isSuper = Boolean(userData?.is_super_user === true || userData?.is_super_user === 1 || userData?.is_super_user === "1" || userData?.is_super_user === "true");
  const isManager = Boolean(isSuper || userData?.manager === true || userData?.manager === 1 || userData?.manager === "1" || userData?.manager === "true");

  const handleGoTraining = () => {
    setTraining(true);
    if (goTraining) {
      goTraining()
        .then(() => setTraining(false))
        .catch(() => setTraining(false));
    }
  };

  const initialOpen = () => {
    if (hasAnyPath(["attendance", "myrota", "leave"])) return "timehub";
    if (hasAnyPath(["jobs", "todo"])) return "workflow";
    if (hasAnyPath(["comrota", "users"])) return "team";
    if (hasAnyPath(["resources", "help-materials", "helpmat"])) return "training";
    if (hasAnyPath(["reports", "evidences"])) return "reports";
    if (hasAnyPath(["myprofile", "userDocument"])) return "account";
    return null;
  };

  const [openSection, setOpenSection] = useState(initialOpen());

  const toggleSection = (key) => (e) => {
    e.preventDefault();
    setOpenSection((prev) => (prev === key ? null : key));
  };

  const getLogo = () => {
    const uData = Utils.getUserData() || userData || {};
    const practiceLogo = _.get(uData, "orglogo") || _.get(uData, "logo") || _.get(uData, "org_logo") || _.get(uData, "practice_logo") || _.get(userData, "orglogo") || _.get(userData, "logo") || _.get(userData, "org_logo") || _.get(userData, "practice_logo") || "";
    return Utils.getLogoUrl(practiceLogo);
  };

  const isSubActive = (path) => (window.location.pathname.indexOf(path) > -1 ? "dt-side-sublink is-active" : "dt-side-sublink");

  return (
    <aside className="dt-sidebar" aria-label="DenTTrack Navigation">
      {/* Brand / Practice Logo Header with high-contrast container */}
      <div className="dt-sidebar__brand">
        <a href={`${process.env.PUBLIC_URL}/dashboard`} className="dt-brand-wrap" title={_.get(userData, "braname") || "DenTTrack"}>
          <img
            src={getLogo()}
            alt={_.get(userData, "braname") || "DenTTrack"}
            className="dt-brand-img"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = process.env.PUBLIC_URL + "/images/logo.png";
            }}
          />
        </a>
      </div>

      {/* Navigation Menu */}
      <div className="dt-sidebar__nav">
        {/* 1. Dashboard */}
        {(userData.is_super_user || Utils.hasAccess(1)) && (
          <a
            className={hasAnyPath(["dashboard"]) ? "dt-side-item is-active" : "dt-side-item"}
            href={`${process.env.PUBLIC_URL}/dashboard`}
          >
            <span className="dt-side-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></svg>
            </span>
            <span className="dt-side-text">Dashboard</span>
          </a>
        )}

        {/* 2. Time Hub */}
        {(userData.is_super_user || Utils.hasAccess(2) || Utils.hasAccess(5)) && (
          <div>
            <a
              href="#timehub"
              className={hasAnyPath(["attendance", "myrota", "leave"]) ? "dt-side-item is-active" : "dt-side-item"}
              onClick={toggleSection("timehub")}
            >
              <span className="dt-side-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 1.9"/></svg>
              </span>
              <span className="dt-side-text">Time Hub</span>
              <span className={`dt-side-chevron ${openSection === "timehub" ? "is-open" : ""}`}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
              </span>
            </a>
            {openSection === "timehub" && (
              <div className="dt-side-sub">
                {(userData.is_super_user || Utils.hasAccess(2)) && (
                  <a className={isSubActive("/attendance")} href={`${process.env.PUBLIC_URL}/attendance`}>
                    • Attendance
                  </a>
                )}
                {(userData.is_super_user || Utils.hasAccess(2)) && (
                  <a className={isSubActive("/myrota")} href={`${process.env.PUBLIC_URL}/myrota`}>
                    • My Rota
                  </a>
                )}
                {(userData.is_super_user || Utils.hasAccess(5)) && (
                  <a className={isSubActive("/leave")} href={`${process.env.PUBLIC_URL}/leave`}>
                    • Holidays
                  </a>
                )}
              </div>
            )}
          </div>
        )}

        {/* 3. Clinical Workflow */}
        {(userData.is_super_user || Utils.hasAccess(3) || Utils.hasAccess(4)) && (
          <div>
            <a
              href="#workflow"
              className={hasAnyPath(["jobs", "todo"]) ? "dt-side-item is-active" : "dt-side-item"}
              onClick={toggleSection("workflow")}
            >
              <span className="dt-side-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 4h6a1 1 0 0 1 1 1v1H8V5a1 1 0 0 1 1-1Z"/><rect x="4" y="6" width="16" height="15" rx="2"/><path d="M9 12h6M9 16h4"/></svg>
              </span>
              <span className="dt-side-text">Clinical Workflow</span>
              <span className={`dt-side-chevron ${openSection === "workflow" ? "is-open" : ""}`}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
              </span>
            </a>
            {openSection === "workflow" && (
              <div className="dt-side-sub">
                {(userData.is_super_user || Utils.hasAccess(3)) && (
                  <a className={isSubActive("/jobs")} href={`${process.env.PUBLIC_URL}/jobs`}>
                    • Daily Jobs
                  </a>
                )}
                {(userData.is_super_user || Utils.hasAccess(4)) && (
                  <a className={isSubActive("/todo")} href={`${process.env.PUBLIC_URL}/todo`}>
                    • Tasks &amp; To-Do
                  </a>
                )}
              </div>
            )}
          </div>
        )}

        {/* 4. CQC Intelligence */}
        {(userData.is_cqc || (userData.is_super_user && Utils.hasAccess(11))) && (
          <a
            className={hasAnyPath(["cqc"]) ? "dt-side-item is-active" : "dt-side-item"}
            href={`${process.env.PUBLIC_URL}/cqc`}
          >
            <span className="dt-side-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3.2 4.5 6v5.6c0 4.4 3 8.2 7.5 9.4 4.5-1.2 7.5-5 7.5-9.4V6L12 3.2Z"/><path d="m9.2 12 2 2 3.6-3.8"/></svg>
            </span>
            <span className="dt-side-text">CQC Intelligence</span>
          </a>
        )}

        {/* 5. Team & Master Rota */}
        {(userData.is_rota || userData.is_super_user || Utils.hasAccess(12)) && (
          <div>
            <a
              href="#team"
              className={hasAnyPath(["comrota", "users"]) ? "dt-side-item is-active" : "dt-side-item"}
              onClick={toggleSection("team")}
            >
              <span className="dt-side-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M3.5 20c0-3.2 2.5-5.5 5.5-5.5s5.5 2.3 5.5 5.5"/><path d="M16.5 5.5a3 3 0 0 1 0 5.6M18 20c0-2.2-.7-4-1.9-5.2"/></svg>
              </span>
              <span className="dt-side-text">Team &amp; Master Rota</span>
              <span className={`dt-side-chevron ${openSection === "team" ? "is-open" : ""}`}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
              </span>
            </a>
            {openSection === "team" && (
              <div className="dt-side-sub">
                {(userData.is_rota || isSuper || Utils.hasAccess(12)) && (
                  <a className={isSubActive("/comrota")} href={`${process.env.PUBLIC_URL}/comrota`}>
                    • Master Rota
                  </a>
                )}
                {isSuper && (
                  <a className={isSubActive("/users")} href={`${process.env.PUBLIC_URL}/users`}>
                    • Team Members
                  </a>
                )}
              </div>
            )}
          </div>
        )}

        {/* 6. Training & CPD */}
        {(isSuper || Utils.hasAccess(6) || Utils.hasAccess(8) || Utils.hasAccess(9)) && (
          <div>
            <a
              href="#training"
              className={hasAnyPath(["resources", "help-materials", "helpmat"]) ? "dt-side-item is-active" : "dt-side-item"}
              onClick={toggleSection("training")}
            >
              <span className="dt-side-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 8.5 12 4l9 4.5-9 4.5-9-4.5Z"/><path d="M7 11v4.5c0 1.4 2.2 2.5 5 2.5s5-1.1 5-2.5V11"/></svg>
              </span>
              <span className="dt-side-text">Training &amp; CPD</span>
              <span className={`dt-side-chevron ${openSection === "training" ? "is-open" : ""}`}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
              </span>
            </a>
            {openSection === "training" && (
              <div className="dt-side-sub">
                <a
                  href="#cpd"
                  className="dt-side-sublink"
                  onClick={(e) => {
                    e.preventDefault();
                    handleGoTraining();
                  }}
                  title="Open CPD Portal"
                >
                  • {training ? "Opening CPD..." : "CPD Portal"}
                </a>
                <a className={isSubActive("/resources")} href={`${process.env.PUBLIC_URL}/resources`}>
                  • Resources
                </a>
                <a
                  href="#howtoguides"
                  className="dt-side-sublink"
                  onClick={(e) => {
                    e.preventDefault();
                    if (setShowHowToModal) setShowHowToModal(true);
                  }}
                >
                  • How To Guides
                </a>
                {isSuper && (
                  <a className={isSubActive("/helpmat")} href={`${process.env.PUBLIC_URL}/helpmat`}>
                    • Manage Help Guides
                  </a>
                )}
              </div>
            )}
          </div>
        )}

        {/* 7. Reports & Evidence */}
        {(isSuper || Utils.hasAccess(7)) && (
          <div>
            <a
              href="#reports"
              className={hasAnyPath(["reports", "evidences"]) ? "dt-side-item is-active" : "dt-side-item"}
              onClick={toggleSection("reports")}
            >
              <span className="dt-side-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 20V10M12 20V4M6 20v-6"/></svg>
              </span>
              <span className="dt-side-text">Reports &amp; Evidence</span>
              <span className={`dt-side-chevron ${openSection === "reports" ? "is-open" : ""}`}>
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
              </span>
            </a>
            {openSection === "reports" && (
              <div className="dt-side-sub">
                <a className={isSubActive("/reports")} href={`${process.env.PUBLIC_URL}/reports`}>
                  • Performance Reports
                </a>
                <a className={isSubActive("/evidences")} href={`${process.env.PUBLIC_URL}/evidences`}>
                  • Evidences
                </a>
              </div>
            )}
          </div>
        )}

        {/* 8. Profile Docs (In main navigation for all users) */}
        <div>
          <a
            href="#account"
            className={hasAnyPath(["myprofile", "userDocument"]) ? "dt-side-item is-active" : "dt-side-item"}
            onClick={toggleSection("account")}
          >
            <span className="dt-side-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 7 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 7 2.6h.1A2 2 0 0 1 9 1h.1" transform="translate(2 2) scale(.86)"/></svg>
            </span>
            <span className="dt-side-text">Profile Docs</span>
            <span className={`dt-side-chevron ${openSection === "account" ? "is-open" : ""}`}>
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
            </span>
          </a>
          {openSection === "account" && (
            <div className="dt-side-sub">
              {isSuper ? (
                <>
                  <a className={isSubActive("/myprofile")} href={`${process.env.PUBLIC_URL}/myprofile`}>
                    • My Profile &amp; Settings
                  </a>
                  <a className={isSubActive("/userDocument")} href={`${process.env.PUBLIC_URL}/userDocument`}>
                    • Upload Documents
                  </a>
                </>
              ) : (
                <a className={isSubActive("/myprofile")} href={`${process.env.PUBLIC_URL}/myprofile`}>
                  • Profile &amp; Documents
                </a>
              )}
            </div>
          )}
        </div>

        {/* 9. Sign Out / Logout Item in Sidebar */}
        <div className="mt-3 pt-2 border-top border-secondary border-opacity-25">
          <a
            href="#logout"
            className="dt-side-item"
            style={{ color: "#FCA5A5" }}
            onClick={(e) => {
              e.preventDefault();
              if (window.confirm("Are you sure you want to sign out?")) {
                window.location.href = `${process.env.PUBLIC_URL}/logout`;
              }
            }}
          >
            <span className="dt-side-icon" style={{ color: "#F87171" }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            </span>
            <span className="dt-side-text">Sign Out / Logout</span>
          </a>
        </div>

        {/* 10. Powered By DenTTrack & Social Media Footer */}
        <div className="mt-auto pt-3 border-top border-secondary border-opacity-25 px-2">
          {/* Powered by DenTTrack Box */}
          <div className="text-center mb-3">
            <div
              className="d-inline-flex flex-column align-items-center justify-content-center px-3 py-1 bg-white rounded"
              style={{ border: "1px solid rgba(255,255,255,0.25)", borderRadius: "8px", boxShadow: "0 2px 6px rgba(0,0,0,0.15)" }}
            >
              <span style={{ fontSize: "9px", color: "#64748B", textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 700 }}>
                Powered by
              </span>
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                alt="DenTTrack"
                style={{ maxHeight: "20px", maxWidth: "120px", objectFit: "contain" }}
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
          </div>

          {/* Social Icons */}
          <div className="d-flex justify-content-center gap-3 mb-2" style={{ opacity: 0.85 }}>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-white text-opacity-75 hover-white" title="Facebook">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-white text-opacity-75 hover-white" title="Twitter">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.936 9.936 0 0024 4.59z"/></svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-white text-opacity-75 hover-white" title="LinkedIn">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-white text-opacity-75 hover-white" title="Instagram">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" className="text-white text-opacity-75 hover-white" title="YouTube">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
